import SpinnerAnimatedIconMedium from './component.jsx'
export default SpinnerAnimatedIconMedium
